module.exports = __webpack_public_path__ + "img/wl_prod1_7.dda4aef8.jpg";